import type { CustomerRow } from "@/lib/types";

/** Lines a table's first and last columns up with the section's own padding. */
export const edgeToEdge =
  "[&_td:first-child]:pl-(--card-spacing) [&_td:last-child]:pr-(--card-spacing) [&_th:first-child]:pl-(--card-spacing) [&_th:last-child]:pr-(--card-spacing)";

export const customerPath = (id: string) =>
  `/customers/${encodeURIComponent(id)}`;

/** The custom link's name, "Main link" for the plain one, "Code" for a code sign-up, or that our team added them. */
export function sourceLabel(row: Pick<CustomerRow, "source" | "linkName">) {
  if (row.source === "code") return "Code";
  if (row.source === "staff") return "Added by our team";
  return row.linkName ?? "Main link";
}
